var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.type === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.message,
      expression: "message"
    }],
    class: _vm.className,
    attrs: {
      "disabled": _vm.isDisabled,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.message) ? _vm._i(_vm.message, null) > -1 : _vm.message
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.doAction($event);
      },
      "change": function change($event) {
        var $$a = _vm.message,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.message = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.message = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.message = $$c;
        }
      }
    }
  }) : _vm.type === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.message,
      expression: "message"
    }],
    class: _vm.className,
    attrs: {
      "disabled": _vm.isDisabled,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.message, null)
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.doAction($event);
      },
      "change": function change($event) {
        _vm.message = null;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.message,
      expression: "message"
    }],
    class: _vm.className,
    attrs: {
      "disabled": _vm.isDisabled,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.message
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.doAction($event);
      },
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value;
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }